import classNames from "classnames";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getImageUrl,
  logout,
  setActiveAppToLocalStorage,
} from "src/helpers/helpers";
import { ArrowIconWithBorder } from "src/icons/ArrowIconWithBorder";
import { LockIcon } from "src/icons/LockIcon";
import { ProfileIcon } from "src/icons/ProfileIcon";
import fallbackUser from "src/images/fallbackUser.webp";
import { setActiveView } from "src/redux/actions/app";
import {
  getActiveApp,
  getActiveView,
  getCurrentUserInfo,
  getUserPlanData,
} from "src/redux/selectors/app";
import { ACTIVE_APP, ACTIVE_VIEW } from "src/utils/constants";
import ContextDropdown from "../dropdowns/ContextDropdown";

const ProfileV2 = () => {
  const currentUserInfo = useSelector(getCurrentUserInfo);
  const userImage = currentUserInfo?.image;

  return (
    <ContextDropdown content={<ProfileDropdown />} placement="bottom">
      <div className="flex gap-[16px] items-center cursor-pointer max-w-[210px]">
        {/* <img
          className="h-14 w-14 rounded-full bg-gray-50 bg-cover"
          src={
            currentUserInfo?.image
              ? getImageUrl(currentUserInfo.image)
              : fallbackUser
          }
          alt=""
        /> */}
        <div
          className="h-14 w-14 rounded-full bg-cover"
          style={{
            backgroundImage: `url(${
              userImage ? getImageUrl(userImage) : fallbackUser
            })`,
          }}
        ></div>
        <div className="flex gap-[17px] items-center truncate">
          <div className=" flex-col text-left truncate hidden sm:flex">
            <div className="text-lg font-bold text-gray-tundora truncate ">
              {currentUserInfo?.name ?? "Anonymous"}
            </div>
            {/* <div className="text-base text-gray-devi">Admin</div> */}
          </div>
          <ArrowIconWithBorder color="#565656" className="shrink-0" />
        </div>
      </div>
    </ContextDropdown>
  );
};

export default ProfileV2;

const ProfileDropdown = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeView = useSelector(getActiveView);
  const hasPlan = useSelector(getUserPlanData);
  const activeApp = useSelector(getActiveApp);

  const handleVendorViewClick = useCallback(() => {
    if (activeView === ACTIVE_VIEW.STANDARD) {
      dispatch(setActiveView(ACTIVE_VIEW.VENDOR));
      navigate("/store/vendor/inventory/all");
    } else {
      dispatch(setActiveView(ACTIVE_VIEW.STANDARD));
      navigate("/store/dashboard");
    }
  }, [activeView, dispatch, navigate]);

  const userNavigation = useMemo(
    () => [
      ...(hasPlan
        ? [
            // { name: "Your profile", icon: ProfileIcon, onClick: () => {} },
            {
              name: "Select App",
              icon: ProfileIcon,
              onClick: () => {
                setActiveAppToLocalStorage("");
                navigate("/select-app");
              },
            },
            ...(activeApp === ACTIVE_APP.STORE
              ? [
                  {
                    name: `${
                      activeView === ACTIVE_VIEW.STANDARD
                        ? "Vendor"
                        : "Standard"
                    } View`,
                    icon: LockIcon,
                    onClick: handleVendorViewClick,
                  },
                ]
              : []),
          ]
        : []),
      {
        name: "Sign out",
        icon: ProfileIcon,
        onClick: () => {
          logout();
          dispatch({ type: "LOGOUT" });
          setTimeout(() => {
            navigate("/login");
          }, 10);
        },
      },
    ],
    [activeApp, activeView, dispatch, handleVendorViewClick, hasPlan, navigate]
  );

  return (
    <div className="flex flex-col py-2 rounded-14px">
      {userNavigation.map(({ name, icon: Icon, onClick }, index) => {
        const isLastElement = index === userNavigation.length - 1;
        return (
          <div
            key={index}
            className={classNames(
              "flex items-center py-[9px] px-[20px] gap-2 cursor-pointer hover:bg-white-ghost text-14px font-semibold",
              { "border-b-[1px]": !isLastElement }
            )}
            onClick={onClick}
          >
            <Icon color="#28303F" />
            {name}
          </div>
        );
      })}
    </div>
  );
};
